import _ from 'lodash'

const mqSet = []

export function add(params) {
    if (!(params && params.mediaquery)) {
        return
    }
    if (!(params && params.name)) {
        return
    }

    const mql = window.matchMedia(params.mediaquery)
    const className = `mq-${_.kebabCase(params.name)}`
    const mqObj = {
        mql,
        name: params.name,
        listener: function () {
            window.document.body.classList[mql.matches ? 'add' : 'remove'](className)
        }
    }

    mqObj.listener()
    mql.addListener(mqObj.listener)
    mqSet.push(mqObj)
}

export function remove(name) {
    const removed = _.remove(mqSet, mqObj => mqObj.name === name)
    if (removed.length) {
        _.each(removed, mqObj => { mqObj.mql.removeListener(mqObj.listener) })
    }
    return !!removed.length
}

export function get() {
    return mqSet
}


// WEBPACK FOOTER //
// ./app/theme/js/utility/mquery.js